// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_2Dn4LpaKme7YOCIIY1s3Id","spaceLeft":"_1i3qa8CBc-jEgFSYXk3hlb","spaceBoth":"_1AhwXylmTS7341vX2_tr-l","spaceRight":"_3yy5pxqVjiDSeIcLa3MWGU","infoText":"_1cIJIjzJB3imauQbi0jIvK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoBoxWithIco.scss
// module id = 1242
// module chunks = 0